import { IUserInfo, IUserUpdateEventRecord } from "@home-health-notify/domain";
import { getGroupStatusProperty } from "hhn-commons";
import React from "react";
import {
  FormDetailItem,
  FormDetailValue,
} from "../../message/messageType/contentType/FormContent.style";
import { TemplateFormTitle, TimelineItemDetails } from "./CareTimeline.style";

const CareTimelineUserUpdateItem = ({
  timelineItem,
  userData,
}: {
  timelineItem: IUserUpdateEventRecord;
  userData: IUserInfo;
}) => {
  const beforeStatusProperties = getGroupStatusProperty(
    timelineItem.data.before.patientStatus,
  );
  const afterStatusProperties = getGroupStatusProperty(
    timelineItem.data.current.patientStatus,
  );
  return (
    <TimelineItemDetails>
      <TemplateFormTitle>
        {userData.title} updated patient status:
      </TemplateFormTitle>
      <FormDetailItem>Before:</FormDetailItem>
      <FormDetailValue color={beforeStatusProperties.upperBarColor}>
        {beforeStatusProperties.title}
      </FormDetailValue>
      <FormDetailItem>After:</FormDetailItem>
      <FormDetailValue color={afterStatusProperties.upperBarColor}>
        {afterStatusProperties.title}
      </FormDetailValue>
    </TimelineItemDetails>
  );
};

export default CareTimelineUserUpdateItem;
